/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import * as moment from 'moment';
import { EventsSeo } from '@app/events/events/events-seo.model';
import { Venue } from '@app/settings/venues/venue.model';
import { Type } from '@app/settings/types/types.model';
import { Industry } from '@app/settings/industries/industries.model';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { HotelBooking } from '@app/hotels/hotel-bookings/hotel-booking.model';
import { City } from '@app/settings/cities/cities.model';

// в множествено число е, защото Event се оказа вече съществуващ интерфейс(не от нас)
export class Events extends Model {
  id: number;
  name: string;
  note: string;
  type_id: number;
  type: Type;
  organizer: string;
  date_from: string;
  date_to: string;
  visitors: number;
  exhibitors: number;
  foreign_exhibitors: number;
  website_url: string;
  link_exhibitors: string;
  year_exhibitors: number;
  industry_id: number;
  industry?: Industry;
  venue_id: number;
  venue?: Venue;
  city_id: number;
  city?: City;
  event_group_id: number;
  event_group: EventGroup;
  show_to_web: boolean;
  active: boolean;
  translations: Array<EventsSeo>;
  hotel_bookings_count?: number;
  hotel_bookings?: Array<HotelBooking>;
  lat?: number;
  long?: number;
  priority_id: number;
  priority?: Type;
  tags: Array<string>;
  rooms_count?: number;
  canceled_rooms_count?: number;
  sold_rooms_count?: number;
  blocked_rooms_count?: number;
  adv_hotel_bookings_rooms_count?: number;
  adv_canceled_rooms_count?: number;
  adv_hotel_bookings_count?: number;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.venue) {
      this.venue = new Venue().deserialize(input.venue);
    }

    if (input.type) {
      this.type = new Type().deserialize(input.type);
    }

    if (input.industry) {
      this.industry = new Industry().deserialize(input.industry);
    }

    if (input.priority) {
      this.priority = new Type().deserialize(input.priority);
    }

    return this;
  }

  get formattedName(): String {
    return this.name + ' - ' + moment(this.date_from).format('YYYY');
  }

  get daysLeftToShow(): Number {
    return moment(this.date_to).diff(moment(), 'days');
  }

  get year(): String {
    return moment(this.date_from).format('YYYY');
  }
}
